export const FacilitiesAssistant = {
    "Facilities": {
        items: [
            // Using
            // Viewing your to do list items
            {
                heading: 'Cloning a facility',
                permissions: ['System Admin'],
                tags: ['clone', 'cloning', 'facility', 'facilities', 'management', 'copy'],
                sections: [
                    {
                        description: 'Navigate to the facilities management screen',
                        styleAs: 'list',
                        // ref: {
                        //     ref: 'ToDoListSelection',
                        //     action: 'highlight'
                        // }
                    },
                    {
                        description: 'Search for the facility you would like to clone',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilitySearch',
                            action: 'highlight'
                        }
                    },

                    {
                        description: 'Select <b>Clone Entire Facility</b>',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityManagementCloneAllButton',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Enter a name for the new facility',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityManagementCloneNewName',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Select continue',
                        styleAs: 'list',
                        // ref: {
                        //     ref: 'ToDoListSelection',
                        //     action: 'highlight'
                        // }
                    },
                    {
                        description: 'The system will clone the facility to the new facilities name',
                        styleAs: 'note',
                        // ref: {
                        //     ref: 'ToDoListSelection',
                        //     action: 'highlight'
                        // }
                    },
                ],
                options: [
                    {
                        option: 'Take me to the facilities management screen',
                        action: {
                            type: 'location',
                            value: '/sys-admin/facilities',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
        ]
    }
}